import classNames from "classnames";
import "./loading.style.scss";

export const LoadingBarTop = () => {
    return(
        <div className="loading-bar-top-wrapper">
            <div className="loading-bar-top"/>
        </div>

    )
}

interface LoadingProps {
    white?: boolean;
}

export const Loading = (props: LoadingProps) => {
    return(
        <div className={classNames(
            "loading-ring-wrapper", {
            "white": props.white
        })}>
            <div/><div/><div/>
        </div>       
    )
}